/** Where the game runs: decides how the player signs in. */
export type Platform = 'web' | 'vk' | 'yandex'

type Env = { search: string; hasYandexSdk: boolean; vkDocument?: boolean }

export function isVkDocument(): boolean {
  return typeof document !== 'undefined' && document.documentElement.dataset.platform === 'vk'
}

/** VK Mini Apps pass signed launch params (vk_* and sign) in the query. */
export function isVkLaunch(search: string): boolean {
  const q = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  if (!q.has('sign')) return false
  for (const key of q.keys()) if (key.startsWith('vk_')) return true
  return false
}

/** Pure detection for tests: VK launch params win, then the Yandex SDK. */
export function detectFrom(env: Env): Platform {
  if (env.vkDocument) return 'vk'
  if (isVkLaunch(env.search)) return 'vk'
  if (env.hasYandexSdk) return 'yandex'
  return 'web'
}

declare global {
  interface Window {
    YaGames?: { init: () => Promise<YandexSdk> }
  }
}

export type YandexSdk = {
  features?: { LoadingAPI?: { ready: () => void } }
  getPlayer: (o: { signed: boolean }) => Promise<{ signature: string }>
}

let detected: Platform | null = null
let launch = ''

/** Determined once at start; later calls return the same answer. */
export function platform(): Platform {
  if (detected) return detected
  launch = typeof window === 'undefined' ? '' : window.location.search
  detected = detectFrom({ search: launch, hasYandexSdk: typeof window !== 'undefined' && typeof window.YaGames?.init === 'function', vkDocument: isVkDocument() })
  return detected
}

/** The original VK launch string, passed to the server unchanged. */
export function vkLaunchParams(): string {
  platform()
  return launch.startsWith('?') ? launch.slice(1) : launch
}

/** Test hook: forget the cached answer. */
export function resetPlatform(): void {
  detected = null
  launch = ''
}

export const PLATFORM_NAME: Record<Platform, string> = { web: 'браузер', vk: 'VK', yandex: 'Яндекс Игры' }
